import type { BlobLike } from "@pdfking/compatibility"
import type { Sequence } from "@pdfking/tfunc"

import type { SpatialRectangle } from "../geometry/SpatialRectangle"
import type { Pixel } from "../units/Units"
import type { PDFReaderOptions } from "./PDFReaderOptions"

export type PDFSplitResult = {
  blob: BlobLike
  media_box: SpatialRectangle<Pixel>
  trim_box: SpatialRectangle<Pixel>
}

export type PDFSplitFunction = (
  input: PDFReaderOptions,
  rangeFn?: (page_count: number) => Sequence<number>
) => AsyncGenerator<PDFSplitResult>
